module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c(this.rootElementType, {
    tag: "component",
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-spin fa-spinner",
    class: _vm.cssClass,
    attrs: {
      "aria-hidden": "true",
      "aria-label": _vm.label
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19c49ebb"}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/loading_icon.vue
// module id = ../../../node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-19c49ebb"}!../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/loading_icon.vue
// module chunks = main